module.exports = __webpack_public_path__ + "static/media/ArrowRight.76cdb1d8.svg";